import React from 'react';

const floatKeyframes = `
  @keyframes shLogoFloat {
    0%, 100% { transform: translateY(0px); }
    50%       { transform: translateY(-6px); }
  }
  @keyframes shHaloPulse {
    0%, 100% { opacity: 0.5; }
    50%       { opacity: 1; }
  }
`;

const ShieldIcon = ({ size = 30 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ filter: 'drop-shadow(0 0 7px rgba(0,245,160,0.8))' }}
  >
    <path
      d="M12 2L3 6V12C3 17.25 7.25 21.75 12 22C16.75 21.75 21 17.25 21 12V6L12 2Z"
      fill="#00F5A0"
      fillOpacity="0.15"
      stroke="#00F5A0"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke="#00F5A0"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SafeheirLogo = ({ size = 'sm' }) => {
  const isLg   = size === 'lg';
  const isIcon = size === 'icon';

  const containerStyle = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...(isIcon
      ? {
          width: '40px',
          height: '40px',
          borderRadius: '10px',
          background: 'rgba(0,245,160,0.07)',
          border: '1px solid rgba(0,245,160,0.18)',
        }
      : {
          gap: isLg ? '12px' : '7px',
          padding: isLg ? '18px 28px' : '8px 14px',
          borderRadius: '14px',
          background: 'rgba(0,245,160,0.04)',
          border: '1px solid rgba(0,245,160,0.15)',
        }),
    animation: 'shLogoFloat 3.5s ease-in-out infinite',
  };

  const textStyle = {
    fontFamily: "-apple-system, 'Segoe UI', sans-serif",
    fontSize: isLg ? '21px' : '14px',
    fontWeight: 600,
    color: '#FFFFFF',
    letterSpacing: '-0.2px',
    lineHeight: 1,
  };

  const haloStyle = {
    position: 'absolute',
    width: isLg ? '160px' : '90px',
    height: isLg ? '60px' : '36px',
    borderRadius: '50%',
    background: 'radial-gradient(ellipse, rgba(0,245,160,0.15) 0%, transparent 70%)',
    animation: 'shHaloPulse 3.5s ease-in-out infinite',
    pointerEvents: 'none',
    zIndex: 0,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  const iconSize = isLg ? 30 : isIcon ? 20 : 18;

  return (
    <>
      <style>{floatKeyframes}</style>
      <div style={containerStyle}>
        <div style={haloStyle} />
        <div style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: isLg ? '12px' : '7px' }}>
          <ShieldIcon size={iconSize} />
          {!isIcon && <span style={textStyle}>Safe<strong>Heir</strong></span>}
        </div>
      </div>
    </>
  );
};

export default SafeheirLogo;
